export const InklePay = () => (
  <svg
    width="161"
    height="56"
    viewBox="0 0 161 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_5723_7881"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="18"
      width="20"
      height="20"
    >
      <path d="M36 18H16V38H36V18Z" fill="white" />
    </mask>
    <g mask="url(#mask0_5723_7881)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 18H16L26 28H16L26 38H36L26 28H36L26 18Z"
        fill="url(#paint0_linear_5723_7881)"
      />
    </g>
    <path
      d="M46 20.4005C46 19.197 46.78 18.417 48.0058 18.417C49.2092 18.417 49.9893 19.197 49.9893 20.4005C49.9893 21.6039 49.2092 22.4063 48.0058 22.4063C46.78 22.4063 46 21.6039 46 20.4005ZM49.7887 37.5164H46.2229V24.1446H49.7887V37.5164Z"
      fill="url(#paint1_linear_5723_7881)"
    />
    <path
      d="M60.7289 30.8082C60.7289 28.847 59.7037 27.5544 58.1214 27.5544C56.6282 27.5544 55.5362 28.9362 55.5362 30.8305V37.5164H51.9704V24.1446H55.5362V25.7046C56.0042 24.7018 57.386 23.9886 58.7677 23.9886C62.1775 23.9886 64.2947 26.7075 64.2947 30.8082V37.5164H60.7289V30.8082Z"
      fill="url(#paint2_linear_5723_7881)"
    />
    <path
      d="M70.0119 37.5164H66.4461V18.573H70.0119V30.1396L74.536 24.1446H78.4362L73.8897 30.8305L78.9042 37.5164H74.38L70.0119 31.5214V37.5164Z"
      fill="url(#paint3_linear_5723_7881)"
    />
    <path
      d="M83.8049 37.5164H80.2391V18.573H83.8049V37.5164Z"
      fill="url(#paint4_linear_5723_7881)"
    />
    <path
      d="M94.6461 33.4157H98.4348C97.5211 35.9118 95.1364 37.6279 92.4175 37.6279C88.5174 37.6279 85.7761 34.7975 85.7761 30.7859C85.7761 26.9081 88.6065 23.9663 92.3506 23.9663C96.0948 23.9663 98.9251 26.9081 98.9251 30.7859C98.9251 31.2094 98.9028 31.6551 98.836 32.0563H89.5203C89.9214 33.4157 91.0135 34.2849 92.3952 34.2849C93.4427 34.2849 94.2673 33.9283 94.6461 33.4157ZM89.5203 29.4933H95.181C94.7799 28.1784 93.7324 27.3316 92.3506 27.3316C90.9689 27.3316 89.9214 28.1784 89.5203 29.4933Z"
      fill="url(#paint5_linear_5723_7881)"
    />
    <path
      d="M111.682 31.4028H107.685V37.6828H105.483V20.3516H111.498C115.026 20.3516 117.411 22.4313 117.411 25.8364C117.411 29.1599 115.067 31.4028 111.682 31.4028ZM111.498 22.5333H107.685V29.2007H111.682C113.721 29.2007 115.209 27.8142 115.209 25.8364C115.209 23.8586 113.7 22.5333 111.498 22.5333Z"
      fill="#41395C"
    />
    <path
      d="M128.274 37.6828V35.3992C127.724 36.8264 125.97 37.8051 124.135 37.8051C120.628 37.8051 118.304 35.3176 118.304 31.5455C118.304 27.7938 120.608 25.3063 124.135 25.3063C125.95 25.3063 127.724 26.285 128.274 27.7326V25.449H130.456V37.6828H128.274ZM120.506 31.5455C120.506 33.9923 122.096 35.6031 124.4 35.6031C126.684 35.6031 128.274 33.9923 128.274 31.5659C128.274 29.1599 126.643 27.488 124.38 27.488C122.076 27.488 120.506 29.0987 120.506 31.5455Z"
      fill="#41395C"
    />
    <path
      d="M144.02 25.449L138.678 38.947C137.76 41.2714 137.19 42.3928 134.743 42.3928H133.988V40.2315H134.539C135.416 40.2315 135.987 39.8645 136.456 38.6819L136.823 37.6828L131.97 25.449H134.315L138.005 34.7467L141.696 25.449H144.02Z"
      fill="#41395C"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5723_7881"
        x1="16"
        y1="28"
        x2="36"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5723_7881"
        x1="46"
        y1="28.0224"
        x2="98.9251"
        y2="28.0224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5723_7881"
        x1="46"
        y1="28.0224"
        x2="98.9251"
        y2="28.0224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5723_7881"
        x1="46"
        y1="28.0224"
        x2="98.9251"
        y2="28.0224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5723_7881"
        x1="46"
        y1="28.0224"
        x2="98.9251"
        y2="28.0224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5723_7881"
        x1="46"
        y1="28.0224"
        x2="98.9251"
        y2="28.0224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
